/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { WorkflowFormBase as WorkflowForm } from './WorkflowForm.base.js'
